import React from 'react';

import { Input, InputGroup, InputRightElement, IconButton, keyframes, Box } from '@vimeo/bokeh';
import { CloseXCircleFilled } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

type SearchCommentProps = {
  updateCommentSearchQuery?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCloseSearch?: () => void;
  searchInputRef?: React.RefObject<HTMLDivElement | null>;
};

const WidthAnimation = keyframes`
    from {
        width: 10%;
    }
    to {
        width: 100%;
    }
`;

export const SearchComments = ({
  updateCommentSearchQuery,
  onCloseSearch,
  searchInputRef,
}: SearchCommentProps) => {
  return (
    <Box width="100%" height="auto" display="flex" justifyContent="flex-end">
      <InputGroup
        display="inline-block"
        size="sm"
        ref={searchInputRef}
        animation={`${WidthAnimation} 250ms ease forwards`}
      >
        <Input
          placeholder={translate('Search comments')}
          _placeholder={{ opacity: 1, color: 'gray.500' }}
          onChange={(e) => updateCommentSearchQuery?.(e)}
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.key === 'Escape') {
              onCloseSearch?.();
            }
          }}
          size="sm"
          autoFocus
        />
        <InputRightElement onClick={onCloseSearch} h="100%">
          <IconButton
            aria-label={translate('Close Search')}
            icon={<CloseXCircleFilled />}
            size="xs"
            variant="tertiary"
          />
        </InputRightElement>
      </InputGroup>
    </Box>
  );
};
